module.exports = __webpack_public_path__ + "static/media/aqua-icon.bff3b464.png";